import { QuerySwitch } from 'components/QuerySwitch';
import { AgencyRequestsComponent } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesSummaryView/AgencyRequests/AgencyRequests.component';
import { FetchAgenciesByAgencyIdsDataProvider } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesSummaryView/AgencyRequests/FetchAgenciesByAgencyIds.data.context';
import { FetchMarketplaceByCommunityIdsDataProvider } from './FetchMarketplaceByCommunityIds.data.context';
import { FC } from 'react';
import {
  FetchCombinedSummaryInfoDataContext,
  FetchCombinedSummaryInfoDataProvider,
} from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesSummaryView/AgencyRequests/FetchCombinedSummaryInfo.data.context';

export const AgencyRequests: FC = () => (
  <FetchAgenciesByAgencyIdsDataProvider>
    <FetchMarketplaceByCommunityIdsDataProvider>
      <FetchCombinedSummaryInfoDataProvider>
        <QuerySwitch
          component={AgencyRequestsComponent}
          context={FetchCombinedSummaryInfoDataContext}
        />
      </FetchCombinedSummaryInfoDataProvider>
    </FetchMarketplaceByCommunityIdsDataProvider>
  </FetchAgenciesByAgencyIdsDataProvider>
);
